// Country-agnostic formatters. Берут единицы/валюту/локаль из meta.json (F1.17).
// Используется в DetailsPanel и других UI компонентах вместо хардкода EUR/km/it-IT.

import type { Meta } from './types';

export const DEFAULT_META_FALLBACK = {
  currency: 'EUR',
  currency_symbol: '€',
  distance_unit: 'km',
  locale: 'it-IT',
};

export function formatMoney(
  value: number | null | undefined,
  meta?: Meta | null,
  opts?: { perYear?: boolean; perM2?: boolean; decimals?: number; lang?: 'en' | 'ru' },
): string {
  if (value == null || !isFinite(value)) return '—';
  const m = meta ?? DEFAULT_META_FALLBACK;
  const decimals = opts?.decimals ?? 0;
  const formatted = new Intl.NumberFormat(m.locale, { maximumFractionDigits: decimals }).format(value);
  // m² and /year are universal: lang-suffix only applies if we add language
  // specifics later. Today we use the SI symbol for area (m²) and a short
  // /yr in EN vs /год in RU to match Russian convention without slipping
  // Cyrillic into an English-locale UI.
  let suffix = ` ${m.currency_symbol}`;
  if (opts?.perM2) suffix += '/m²';
  if (opts?.perYear) suffix += opts?.lang === 'en' ? '/yr' : '/год';
  return formatted + suffix;
}

export function formatDistance(value: number | null | undefined, meta?: Meta | null, decimals = 1): string {
  if (value == null || !isFinite(value)) return '—';
  const m = meta ?? DEFAULT_META_FALLBACK;
  return `${value.toFixed(decimals)} ${m.distance_unit}`;
}

export function formatNumber(value: number | null | undefined, meta?: Meta | null, decimals = 0): string {
  if (value == null || !isFinite(value)) return '—';
  const m = meta ?? DEFAULT_META_FALLBACK;
  return new Intl.NumberFormat(m.locale, { maximumFractionDigits: decimals }).format(value);
}
